export enum SubjectFeedbackForGradeModalTypeEnum {
    ATTITUDE_AND_WORK_ETHIC = "attitude",
    PERFORMANCE = "performance",
    COMMENT = "comment"
}